import React from 'react';
import { connect } from 'react-redux';
import { setCurrentPage } from './currentPage';
import { setCompetitionTab } from './currentTab';
import { SCR_OVERVIEW, SCR_COMPETITION, TAB_CATEGORIES, SCR_PROFILE, API_LOGOUT } from '../enums';
import { getLabel } from '../Language/labels';
import http from '../http';

const TopMenu = ({ loggedInUser, dispatch }) => {

  const navigateToCategories = () => {
    dispatch(setCompetitionTab(TAB_CATEGORIES));
    dispatch(setCurrentPage(SCR_COMPETITION));
  }

  const logout = async () => {
    await http.get(API_LOGOUT);
    window.location.reload();
  }

  return (
    <div>
      {loggedInUser && 
      <div className='top-menu'>
        <div>
          <h3>{`Logged in as ${loggedInUser.name}`}</h3>
        </div>
        <div>
          <span onClick={() => dispatch(setCurrentPage(SCR_OVERVIEW))} className='top-menu-link'>{getLabel('menuEntries')}</span>
          <span onClick={() => dispatch(setCurrentPage(SCR_PROFILE))} className='top-menu-link'>{getLabel('profileScreenTitle')}</span>
          <span onClick={navigateToCategories} className='top-menu-link'>{getLabel('menuCategories')}</span>
          <span onClick={logout} className='top-menu-link last'>{getLabel('menuLogout')}</span>
        </div>
      </div>}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.loginState
  }
}

export default connect(mapStateToProps)(TopMenu)